import { PortfolioPageInsightItem } from "@/components/portfolio/portfolio-page/PortfolioPageInsightItem";
import { PortfolioPageSectionBadge } from "@/components/portfolio/portfolio-page/PortfolioPageSectionBadge";
import { useLanguage } from "@/context/LanguageContext";
import { Panel } from "@/components/ui/Panel";
import {
  BuildingOfficeIcon,
  BuildingLibraryIcon,
} from "@heroicons/react/24/outline";

export function PortfolioOverviewIntroPanel() {
  const { language } = useLanguage();
  const copy = {
    cs: {
      portfolio: "Portfolio nemovitostí",
      summaryAndDetail: "Souhrn i detail",
      summaryAndDetailText:
        "Jedním kliknutím přepnete mezi celým portfoliem a konkrétní nemovitostí.",
      taxOverview: "Daňový přehled",
      taxOverviewText:
        "Nastavte si své transakce na nemovitosti, a rovnou uvidíte daňový přehled",
    },
    en: {
      portfolio: "Property portfolio",
      summaryAndDetail: "Summary and detail",
      summaryAndDetailText:
        "Switch between the whole portfolio and a specific property with one click.",
      taxOverview: "Tax overview",
      taxOverviewText:
        "Set up property transactions and immediately see the tax overview.",
    },
  }[language];

  return (
    <Panel>
      <div className="space-y-1">
        <PortfolioPageSectionBadge type={"dark"}>
          {copy.portfolio}
        </PortfolioPageSectionBadge>
      </div>

      <div className="mt-4 space-y-2">
        <PortfolioPageInsightItem
          icon={BuildingOfficeIcon}
          title={copy.summaryAndDetail}
          text={copy.summaryAndDetailText}
        />
        <PortfolioPageInsightItem
          icon={BuildingLibraryIcon}
          title={copy.taxOverview}
          text={copy.taxOverviewText}
        />
      </div>
    </Panel>
  );
}
